// extracted by mini-css-extract-plugin
module.exports = {"content":"XzNN0AHF","hot":"__67nG_68j","title":"MaqUhnAE","time":"i_5WTaAX","right":"__18BCB_RC","remainingDaysLeft":"xuxDsefd","remainingDaysRight":"rzl2qCqq","active":"m35De9B3"};